import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ConstantsService } from '@app/common/constants.service';
import { AlertService } from '@app/shared/services/alert.service';
import { CommonService } from '@app/shared/services/CommonService';
import { MenuContextualService } from '@app/shared/services/menu-contextual.service';
import { UserService } from '@app/shared/services/user.service';
import { delay, firstValueFrom, Observable, of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { UserDto } from '@app/apiModules/userDto';
import { ChangeDetectorRef } from '@angular/core';
import { ripple, textField, formField } from 'material-components-web';
import { LoaderService } from '@app/shared/services/loader.service';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';

export interface Person {
  mail: string;
}
@Component({
    standalone: true,
    selector: 'add-users',
    templateUrl: './add-users.component.html',
    styleUrl: './add-users.component.scss',
    imports: [NgSelectModule, CommonModule, FormsModule, ReactiveFormsModule]
})
export class AddUsersComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() public roleList: any;
  @Input() editdata: UserDto;
  @ViewChild('emailNgSelect') emailNgSelect: NgSelectComponent;


  userForm: UntypedFormGroup;
  people$: Observable<Person[]> = of([]);
  data: UserDto;
  disableUser = false;
  adSearchMode = false;
  submitted = false;
  roleNames: any;
  showUserForm = true;
  userTenantId: string;
  emailPattern: string;
  passwordToolTip: string;
  passwordPattern: string;
  phoneNumberPattern: string;
  approve = false;
  approveDisbaled = false;
  selectList;
  tenantDomains: any;
  domainsList: any;
  domainFilteredUserList: any;
  tenantID: string;
  jobList: any = [];
  filteredRoles: any[];
  searchText = '';
  loading: boolean;

  constructor(public userService: UserService,
    public formBuilder: UntypedFormBuilder, public commonService: CommonService,
    public alertService: AlertService, public constantService: ConstantsService,
    public loaderService: LoaderService,
    public cdr: ChangeDetectorRef,
    public viewContainerRef: ViewContainerRef, public toastr: ToastrService,

    private contextMenu: MenuContextualService) { }

  @Output('getUserDetails') getUsers: EventEmitter<any> = new EventEmitter();
  @Output() closeSlider: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    this.filteredRoles = this.roleList;
    this.selectList = null;
    this.userForm = this.formBuilder.group({
      id: [null],
      displayName: [null],
      name: ['', Validators.pattern(/^[a-zA-ZÀ-ÿ'-\s]{1,50}$/)],
      surname: ['', Validators.pattern(/^[a-zA-ZÀ-ÿ'-\s]{1,50}$/)],
      email: ['', [
        Validators.maxLength(256), Validators.required,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,50}$/) // Standard email validation
      ]],
      phoneNumber: [null],
      userPrincipalName: [null],
      selectedRoleIds: new UntypedFormArray([]),
      isActive: [false],
      emailConfirmed: [false],
    });
  }
  getPeople(items: any[], term: string = null): Observable<Person[]> {
    if (term) {
      items = items.filter(x => x.mail && x.mail.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1);
    }
    return of(items).pipe(delay(1));
  }

  close() {
    this.clearForm();
    this.closeSlider.emit();
  }

  closeUserSearch() {
    this.clearForm();
  }

  onClick(event: MouseEvent, dataObject, origin, menuTemplate) {
    this.contextMenu.open(event, this.viewContainerRef, dataObject, origin, menuTemplate);
  }

  tabChanged(event) {
    if (event.index === 1) {
      //this.GetBulkUploadJobList();
    }
  }

  clearForm() {

    this.submitted = false;
    this.roleNames = null;
    this.approve = false;
    this.approveDisbaled = false;
    this.filteredRoles = this.roleList;
    // for each item in filteredRoles, set checked to false
    this.filteredRoles.forEach(item => item.checked = false);
    this.people$ = of([]);
    this.userForm.reset();

  }

  /**
   * Retrieves Active Directory users based on a keyword.
   * @param keyword The keyword used to search for users.
   */
  getADUsers($event) {
    if ($event.term && $event.term.length > 3) {
      this.userService.apiAppUserADUsersGet($event.term).subscribe({
        next: (res) => {
          // res.value is the array of users
          this.people$ = this.getPeople(res.value, $event.term);
        },
        error: (_error) => {
          this.alertService.buildDialog().fire({
            icon: this.alertService.ErrorIcon,
            showCancelButton: false,
            cancelButtonText: '',
          });
        }
      });
    }
  }

  noop() { } // no-operation empty event 
  setLoader() {
    this.loading = true;
    this.loaderService.showSpinner.next(true);
  }
  setUnLoader() {
    this.loading = false;
    this.loaderService.showSpinner.next(false);
  }

  ngOnChanges(_changes: SimpleChanges) {
    this.filteredRoles = this.roleList;
    if (this.editdata) {
      this.setLoader();
      setTimeout(() => {
        firstValueFrom(this.userService.apiAppUserbyUserIdGet(this.editdata.id)).then((res) => {
          if (res && res.id) {
            this.userService.apiAppUserADUsersGet(res.email).subscribe({
              next: (res) => {
                this.disableUser = true;
              }
            });
            this.userForm.patchValue({
              concurrencyStamp: res.concurrencyStamp,
              id: res.id,
              displayName: res.displayName,
              name: res.name || '',
              surname: res.surname || '',
              email: res.email || '',
              phoneNumber: '',
              isActive: res.isActive,
              emailConfirmed: res.emailConfirmed || false,
            });

            const selectedRoleIdsArray = new UntypedFormArray(
              (res.selectedRoleIds || [])
                .filter(roleId => roleId !== null && roleId !== undefined)
                .map(roleId => new UntypedFormControl(roleId))
            );

            this.userForm.setControl('selectedRoleIds', selectedRoleIdsArray);

            const selectedRoleIds = this.userForm.get('selectedRoleIds')?.value || [];

            this.filteredRoles = this.filteredRoles.map(role => ({
              ...role,
              checked: selectedRoleIds.includes(role.id)
            }));
            this.onCheckChangeApprove(this.userForm.value.isActive);
            this.setUnLoader();
          }
        });
      }, 1000);



    }

  }


  onSearchChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    if (this.searchText) {
      this.filteredRoles = this.roleList.filter(item =>
        item.name.toLowerCase().includes(this.searchText.toLowerCase())
      );
    } else {
      this.filteredRoles = this.roleList;
    }
  }
  async onCheckChange(checked: boolean, roleId: string | number, item: any) {
    const formArray: UntypedFormArray = this.userForm.get('selectedRoleIds') as UntypedFormArray;
    let isAdmin = false;
    try {
      isAdmin = await this.commonService.checkLoggedUserIsAdmin();
    } catch (error) {
      isAdmin = false;
    }
    if (!isAdmin) {
      const isModifyingAdminRole = this.isUserModifyingAdminRole(item);
      if (isModifyingAdminRole) 
      {
        this.toastr.error('Not allowed to add user with admin role', 'Error');
        item.checked = checked ? false : true;
        return;
      }
    }
    if (checked) {
      formArray.push(new UntypedFormControl(roleId));
    } else {
      let i = 0;
      formArray.controls.forEach((ctrl: UntypedFormControl) => {
        if (ctrl.value == roleId) {
          formArray.removeAt(i);
          return;
        }
        i++;
      });
    }
    if (formArray.controls.length > 0) {
      this.approveDisbaled = true;
    }
    else {
      this.onCheckChangeApprove(false);
      this.approveDisbaled = false;
    }
  }
  isUserModifyingAdminRole(item: any) {
    return item.name.toLowerCase() == 'hostadmin' ? true : false;
  }
  onCheckChangeApprove(isActive) {
    if (isActive) {
      this.approve = true;
      this.userForm.controls['isActive'].setValue(true);

    } else {
      this.approve = false;
      this.userForm.controls['isActive'].setValue(false);
    }

    if (this.userForm.get('selectedRoleIds')?.value.length > 0) {
      this.approveDisbaled = true;
    }
    else {
      this.approveDisbaled = false;
    }

  }
 /* istanbul ignore next */
  initMatComponent() {
    [].forEach.call(document.querySelectorAll('.text-material'), function (element) {
      if (element && element.querySelector('.mdc-text-field__input')) {
        textField.MDCTextField.attachTo(element);
      }
    });

    [].map.call(document.querySelectorAll('.ripple-material'), function (el) {
      ripple.MDCRipple.attachTo(el);
    });
  }
  /* istanbul ignore next */
  ngAfterViewInit() {
    setTimeout(() => {
      [].forEach.call(document.querySelectorAll('.text-material'), function (element) {
        if (element && element.querySelector('.mdc-text-field__input')) {
          textField.MDCTextField.attachTo(element);
        }
      });
      [].forEach.call(document.querySelectorAll('.ripple-material'), function (el) {
        if (el) {
          ripple.MDCRipple.attachTo(el);
        }
      });
      [].forEach.call(document.querySelectorAll('.formfield-material'), function (elem) {
        if (elem) {
          formField.MDCFormField.attachTo(elem);
        }
      });
    }, 2000);
  }

  IsNullOrEmpty(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    return false;
  }
  validateBeforeSave() {
    if(this.userForm.value.selectedRoleIds && this.userForm.value.selectedRoleIds.length == 0) {
      this.toastr.error('Please select at least one role', 'Error');
      return;
    }

    if (this.editdata && this.editdata.id && this.editdata.isActive == true && this.userForm.value.isActive == false) {
        this.alertService.buildDialog().fire({
          title: 'Are you sure?',
          text: 'Are you sure you want to unapprove user access?',
          icon: this.alertService.WarningIcon,
          showCancelButton: true,
          confirmButtonText: 'Yes, Inactive!',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (!result.isConfirmed) {
            return false;
          }
          else {
            this.save(null);
          }
        });
    }
    else{
      this.save(null);
    }
  }
  save(event: any) {

    this.userForm.value.isActive = this.userForm.value.isActive === true ? true : false;

    this.userForm.value.selectedRoleIds = this.userForm.value.selectedRoleIds.filter(id => id !== null);
    const userDto: UserDto = this.userForm.value;
    if (!(this.userForm.value.id && this.userForm.value.isActive == false)) {
      this.userForm.value.emailConfirmed = true;
    }
    this.userForm.value.displayName = this.userForm.value.name + ' ' + this.userForm.value.surname;
    this.userForm.value.userPrincipalName = this.userForm.value.email;
    if (userDto) {
      if (this.editdata && this.editdata.id) {
        this.userService.apiAppUpdateUsersPost(userDto).subscribe(
          {
            next: (res) => {
              this.clearForm();
              this.getUsers.emit();
              this.closeSlider.emit();
              if (res == this.constantService.success) {

                let toastMsg = '';
                toastMsg = 'User updated successfully';
                this.toastr.success(toastMsg, '');

              }
            },
            error: (_error) => {

              this.alertService.buildDialog().fire({
                title: 'Error',
                text: '',
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: 'OK',
                cancelButtonText: '',
              });
              this.clearForm();
              this.closeSlider.emit();
            }
          });
        this.initMatComponent();
      }
      else {
        this.userService.apiAppUserADUsersPost(userDto).subscribe(
          {
            next: (res) => {
              this.clearForm();
              this.getUsers.emit();
              this.closeSlider.emit();
              if (res == this.constantService.success) {

                let toastMsg = '';
                toastMsg = 'User added successfully';
                this.toastr.success(toastMsg, '');

              } else if (res == this.constantService.alreadyRegistered) {
                this.alertService.buildDialog().fire({
                  title: 'Error!',
                  text: 'User already exists',
                  icon: this.alertService.ErrorIcon,
                  showCancelButton: false,
                  confirmButtonText: 'OK',
                  cancelButtonText: '',
                });
              }
            },
            error: (_error) => {

              this.alertService.buildDialog().fire({
                title: 'Error',
                text: '',
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: 'OK',
                cancelButtonText: '',
              });
              this.clearForm();
              this.closeSlider.emit();
            }
          });
      }
    }
  }


  onEmailSelect(user: any) {
    if (user) {
      this.userForm.patchValue({
        email: user.mail || '',
        name: user.givenName || '',
        surname: user.surname || '',
        // phoneNumber: user.mobilePhone || ''
      });
    }

    if (this.emailNgSelect && this.emailNgSelect.searchInput) {
      this.emailNgSelect.searchInput.nativeElement.blur();
    }
    // Explicitly mark phoneNumber as touched and dirty
    // const phoneControl = this.userForm.get('phoneNumber');
    // phoneControl?.markAsTouched();
    // phoneControl?.markAsDirty();
    // phoneControl?.updateValueAndValidity();
  }
}
